import type { BoxProps } from '@chakra-ui/react';
import { Box } from '@chakra-ui/react';

export type MaskIconProps = BoxProps & {
  icon: string;
};
export const MaskIcon = ({ icon, ...props }: MaskIconProps) => {
  return (
    <Box
      w="24px"
      h="24px"
      bg="currentcolor"
      {...props}
      css={{
        maskImage: icon,
        maskSize: '100% 100%',
        maskRepeat: 'no-repeat',
        maskComposite: 'exclude',
        /**
         * override auto-generated property `-webkit-mask-composite`
         */
        WebkitMaskComposite: 'xor',
        maskPosition: 'center center',
        ...props.css,
      }}
    />
  );
};
